import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from '../../../../../environments/environment';
import { CommonService } from '../../common-service';
import { GetPedidoExtracaoResponse } from '../../responses/batch-extracao-dados/get-pedido-extracao.response';
import { PostPedidoExtracaoResponse } from '../../responses/batch-extracao-dados/post-pedido-extracao.response';
import { PedidoExtracaoRequest } from '../../requests/batch-extracao-dados/pedido-extracao.request';
import { ListPedidoExtracaoResponse } from '../../responses/batch-extracao-dados/list-pedido-extracao.response';

@Injectable({
  providedIn: 'root',
})
export class PedidoExtracaoService extends CommonService {
  // Ajuste a URL base conforme a configuração do seu environment.ts
  private readonly apiUrl: string = environment.urlApiBatchExtracaoDados + 'PedidoExtracao';

  constructor(
    private httpClient: HttpClient
  ) {
    super();
  }

  /**
   * Endpoint para criar um novo pedido de extração de dados.
   * Corresponde a: [HttpPost] /PedidoExtracao
   * @param request O corpo da requisição com os dados do pedido.
   */
  public post(request: PedidoExtracaoRequest): Observable<PostPedidoExtracaoResponse> {
    return this.httpClient
      .post<PostPedidoExtracaoResponse>(this.apiUrl, request, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  /**
   * Endpoint para buscar um pedido de extração pelo seu ID.
   * Corresponde a: [HttpGet] /PedidoExtracao/idPedidoExtracao/{idPedidoExtracao}
   * @param idPedidoExtracao O ID do pedido de extração a ser buscado.
   */
  public getById(idPedidoExtracao: number): Observable<GetPedidoExtracaoResponse> {
    const url = `${this.apiUrl}/idPedidoExtracao/${idPedidoExtracao}`;
    return this.httpClient
      .get<GetPedidoExtracaoResponse>(url, this.addHeaderToken())
      .pipe(catchError(this.handleError));
  }

  public getAll(idTipoExtracao: number[], idStatusExtracao: number[], pageIndex: number = 0): Observable<ListPedidoExtracaoResponse> {
    let params = new HttpParams().set('pageIndex', pageIndex.toString());

    (idTipoExtracao || []).forEach(id => {
      params = params.append('idTipoExtracao', id.toString());
    });
    (idStatusExtracao || []).forEach(id => {
      params = params.append('idStatusExtracao', id.toString());
    });

    return this.httpClient
      .get<ListPedidoExtracaoResponse>(`${this.apiUrl}/getAll`, { params, ...this.addHeaderToken() })
      .pipe(catchError(this.handleError));
  }
}